webpackJsonp([11],{

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(597)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(553),
  /* template */
  __webpack_require__(637),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2267ca8b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 553:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: false,
      user: {
        phone: '',
        password: ''
      },
      rules: {
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    };
  },

  methods: {
    notifyErr: function notifyErr(msg) {
      this.$notify.error({
        title: '错误',
        message: msg,
        offset: 100
      });
    },
    login: function login() {
      var _this = this;

      console.log('login...');
      this.$refs.login.validate(function (valid) {
        if (valid) {
          _this.loading = true;
          _this.$store.dispatch('Login', _this.user).then(function () {
            _this.loading = false;
            _this.$router.push({ name: 'welcome' });
          }).catch(function (err) {
            console.log(err);
            _this.loading = false;
            _this.notifyErr(err);
          });
        } else {
          console.log('error submit!!');
          _this.notifyErr('请输入正确的用户名密码');
          return false;
        }
      });
    }
  }
});

/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(253)(true);
// imports


// module
exports.push([module.i, ".title[data-v-2267ca8b]{font-size:26px;font-weight:400;margin:0 auto 20px;text-align:center;font-weight:700}.loginConter[data-v-2267ca8b]{min-height:200px}.loginConter[data-v-2267ca8b],.logostyle[data-v-2267ca8b]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#324057}.logostyle[data-v-2267ca8b]{min-height:calc((100vh - 200px)/2)}.login[data-v-2267ca8b]{width:30%;min-width:200px;box-shadow:0 0 10px #000;padding:20px 20px 0;border-radius:5px;background-color:#fff}.loginBtn[data-v-2267ca8b]{width:100%}", "", {"version":3,"sources":["E:/mywork/math/mathManager/src/pages/login.vue"],"names":[],"mappings":"AACA,wBACE,eAAgB,AAChB,gBAAiB,AACjB,mBAA2B,AAC3B,kBAAmB,AACnB,eAAkB,CACnB,AACD,8BAEE,gBAAkB,CAWnB,AACD,0DAbE,WAAY,AAEZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAA0B,CAe3B,AAbD,4BAEE,kCAAoC,CAWrC,AACD,wBACE,UAAW,AACX,gBAAiB,AACjB,yBAA2B,AAC3B,oBAA0B,AAC1B,kBAAmB,AACnB,qBAAwB,CACzB,AACD,2BACE,UAAY,CACb","file":"login.vue","sourcesContent":["\n.title[data-v-2267ca8b] {\n  font-size: 26px;\n  font-weight: 400;\n  margin: 0px auto 20px auto;\n  text-align: center;\n  font-weight: bold;\n}\n.loginConter[data-v-2267ca8b]{\n  width: 100%;\n  min-height: 200px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background-color: #324057;\n}\n.logostyle[data-v-2267ca8b]{\n  width: 100%;\n  min-height: calc((100vh - 200px)/2);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background-color: #324057;\n}\n.login[data-v-2267ca8b]{\n  width: 30%;\n  min-width: 200px;\n  box-shadow: 0 0 10px black;\n  padding: 20px 20px 0 20px;\n  border-radius: 5px;\n  background-color: white;\n}\n.loginBtn[data-v-2267ca8b]{\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(570);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(254)("602b15a8", content, true);

/***/ }),

/***/ 637:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "logostyle"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('img', {
    staticStyle: {
      "height": "166px",
      "width": "130px"
    },
    attrs: {
      "src": "/static/img/logo.png"
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loginConter"
  }, [_c('el-form', {
    ref: "login",
    staticClass: "login",
    attrs: {
      "model": _vm.user,
      "label-width": "80px",
      "rules": _vm.rules
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("登录")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "phone"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.user.phone),
      callback: function($$v) {
        _vm.user.phone = $$v
      },
      expression: "user.phone"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-user",
    slot: "prepend"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.login($event)
      }
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.user.password = $$v
      },
      expression: "user.password"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-iconfontlock",
    slot: "prepend"
  })])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "loginBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "logostyle"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/11.9cc999628239eeeedd75.js